// extracted by mini-css-extract-plugin
module.exports = {"cover-story":"CoverStory_cover-story__b7ssK"};